import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';

configure({ enforceActions: 'always' });

class ShipmentStore extends StoreModel {
    constructor() {
        super('shipment', {
            namePlural: 'shipments',
            sort: '-shipDate',
            api: {
                search: {
                    url: '/api/shipments/admin/',
                    params: {},
                },
                load: {
                    url: '/api/shipments/admin/',
                    params: {},
                },
                save: {
                    url: '/api/shipments/',
                    params: {},
                },
                delete: {
                    url: '/api/shipments/',
                    params: {},
                },
            },
            queryFilter: {},
        });
    }

    @observable shipment = {};

    @observable shipments = [];
}

const store = new ShipmentStore();
export default store;



// WEBPACK FOOTER //
// ./stores/shipment.js